module.exports = __webpack_public_path__ + "img/blit-vip.cadab219.png";